module.exports = __webpack_public_path__ + "f76553a09abfab85d3d3e799eee6d161.svg";